/* CheckBoxEditor.js */

"use strict";

const CommonEditor = require("../CommonEditor");
const getDefaultCreateValue = require("./mapDataUtil");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;

class CheckBoxEditor extends CommonEditor {
    constructor(options) {
        super(options);
    }

    _createInput() {
        return new InputCheckboxControl({
            darkTheme: true,
        });
    }

    loadValue(item) {
        const fieldValue = item[this._fieldName];
        this.initialData = fieldValue;
        this.input.setValue(fieldValue);
    }

    applyValue(item, state) {
        item[this._fieldName] = state;
        if (state) {
            if (item.netBoxPlatform) {
                item.netBoxName = getDefaultCreateValue(item.vendor, undefined, item.vendorOptions);
            }
            if (item.netBoxDeviceType) {
                item.netBoxName = getDefaultCreateValue(item.vendor, undefined, item.vendorOptions);
            }
        } else {
            if (item.netBoxPlatform) {
                item.netBoxName = getDefaultCreateValue(
                    item.vendor,
                    item.pfValue,
                    item.vendorOptions
                );
            }
            if (item.netBoxDeviceType) {
                item.netBoxName = getDefaultCreateValue(
                    item.vendor,
                    item.skuValue,
                    item.vendorOptions,
                    [],
                    false
                );
            }
        }
    }

    hide() {}
    show() {}

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = CheckBoxEditor;
